import { type FC, type ElementType } from 'react';
import {
  uiStyles,
  UiButton,
  UiButtonProps,
} from '@/lib/ui';
import { UiTooltip } from '@/lib/ui/Tooltip';

export interface PlainIconProps extends UiButtonProps {
  label: string
  Icon: ElementType
  color?: UiButtonProps['color']
  iconSize?: UiButtonProps['size']
}

const PlainIcon: FC<PlainIconProps> = ({
  label,
  Icon,
  color = 'primary.500',
  iconSize = '2xl',
  ...props
}) => {

  return (
    <UiTooltip label={label} borderRadius={uiStyles.borderRadius}>
      <UiButton
        variant={'ghost'}
        {...uiStyles.hover}
        {...props}
      >
        <Icon size={iconSize} color={color}/>
      </UiButton>
    </UiTooltip>
  );
};

export default PlainIcon;
